const FIND_CACHE_MAX_AGE_MS = 5 * 60 * 1000;

let cache = {
  shifts: null,
  stores: null,
  focusShiftId: null,
  focusStoreId: null,
  savedAt: 0,
};

const isFresh = () => cache.savedAt > 0 && (Date.now() - cache.savedAt) <= FIND_CACHE_MAX_AGE_MS;

/**
 * In-memory Find page cache (survives Find remount within the same tab).
 * Avoids stuffing large shift/store arrays into router history state.
 */
export const saveFindCache = ({ shifts, stores } = {}) => {
  cache = {
    ...cache,
    shifts: shifts !== undefined ? shifts : cache.shifts,
    stores: stores !== undefined ? stores : cache.stores,
    savedAt: Date.now(),
  };
};

/** Remember which map card to restore after returning from shift detail. */
export const saveFindFocus = (shiftId, storeId) => {
  cache = {
    ...cache,
    focusShiftId: shiftId != null ? String(shiftId) : null,
    focusStoreId: storeId != null ? String(storeId) : null,
  };
};

/** Clear restored focus so carousel scrolling is not forced back. */
export const clearFindFocus = () => {
  cache = {
    ...cache,
    focusShiftId: null,
    focusStoreId: null,
  };
};

export const readFindCache = () => {
  if (!isFresh()) {
    return { shifts: null, stores: null, focusShiftId: null, focusStoreId: null };
  }
  return {
    shifts: cache.shifts,
    stores: cache.stores,
    focusShiftId: cache.focusShiftId,
    focusStoreId: cache.focusStoreId,
  };
};

export const clearFindCache = () => {
  cache = { shifts: null, stores: null, focusShiftId: null, focusStoreId: null, savedAt: 0 };
};
